import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';

import { styled } from '@mui/material/styles';
import { theme } from 'venuescanner-js/theme';

import GuestsFieldMui from './GuestsFieldMui';
import LocationFieldMui from './LocationFieldMui';

const SearchBarContainer = styled(Grid)(() => ({
  padding: '0 16px 16px 16px',
  minWidth: '50px',
  maxWidth: '913px',
  backgroundColor: '#FFF',
  borderRadius: '8px',
  boxShadow:
    '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
  [theme.breakpoints.down('md')]: {
    padding: '24px',
  },
}));

const CtaContainer = styled(Grid)(() => ({
  [theme.breakpoints.up('md')]: {
    paddingLeft: '6px',
  },
}));

const FindMoreVenuesButton = styled(Button)(() => ({
  fontSize: '17px',
  fontWeight: 400,
  lineHeight: '28px',
  letterSpacing: '0.46px',
  height: '48px',
  width: '181px',
  padding: '0px',
  boxShadow:
    '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

const SearchBarMui = ({ tag, place }) => {
  const [numberGuests, setNumberGuests] = useState('');
  const defaultLocation = place
    ? {
        category: place.kind,
        label: place.label,
        kind: place.kind,
        value: place.value,
      }
    : null;

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    resetField,
  } = useForm({ defaultValues: { location: defaultLocation } });

  const handleWebflowSubmit = formData => {
    window?.dataLayer?.push({
      event: 'Click',
      event_category: 'Book venue - SEO',
      event_label: 'venue_finder',
    });
    const useLocationSlug = false;
    const useTagSlug = true;
    const baseUrl =
      process.env.WEBFLOW_VENUE_FINDER_URL ??
      'https://pages.venuescanner.com/venue-finder/venue-finder?';
    onSubmit(formData, { useLocationSlug, useTagSlug, baseUrl });
  };

  const getQueryString = (formData, { useLocationSlug, useTagSlug }) => {
    const queryParams = [
      {
        location: useLocationSlug
          ? formData.location.value
          : formData.location.label,
      },
      { capacity: formData.capacity },
    ];

    if (tag) {
      queryParams.push({ tag: useTagSlug ? tag.value : tag.label });
    }

    const queryString = queryParams
      .map(item => `${Object.keys(item)[0]}=${Object.values(item)[0]}`)
      .join('&');

    return queryString;
  };

  const onSubmit = (formData, { useLocationSlug, useTagSlug, baseUrl }) => {
    const queryParams = getQueryString(formData, {
      useLocationSlug,
      useTagSlug,
    });
    const newUrl = `${baseUrl}${queryParams}`;
    location.assign(encodeURI(newUrl));
  };

  return (
    <SearchBarContainer
      container
      component='form'
      rowSpacing={{ xs: 2 }}
      direction='row'
      alignItems='center'
      justifyContent='center'>
      <Grid item xs={12} md={5}>
        <LocationFieldMui
          error={{
            show: errors.location?.type === 'required',
            message: 'Please select a location',
          }}
          control={control}
          onFocus={() => {
            if (errors.location) {
              resetField('location');
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <GuestsFieldMui
          value={numberGuests}
          onChange={e => setNumberGuests(e.target.value)}
          register={register}
        />
      </Grid>
      <CtaContainer
        container
        item
        alignItems='center'
        justifyContent='center'
        xs={12}
        md={4}>
        <FindMoreVenuesButton
          variant='contained'
          size='large'
          onClick={handleSubmit(handleWebflowSubmit)}>
          Start
        </FindMoreVenuesButton>
      </CtaContainer>
    </SearchBarContainer>
  );
};

SearchBarMui.propTypes = {
  tag: PropTypes.object,
  place: PropTypes.object,
};

export default SearchBarMui;
